import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
const Container = styled.div `
  padding: 18px 24px;
  margin: 0 -24px -24px;
  background-color: ${theme.greys.glamdring};
  box-shadow: inset 0 1px 0 0 ${theme.greys.geyser};
  border-radius: 0 0 8px 8px;
`;
const KeysItem = styled.div `
  display: inline-block;
  margin-right: 16px;
`;
export const KeysColor = styled.div `
  display: inline-block;
  vertical-align: middle;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  margin-right: 8px;
  background: ${(props) => props.color};
`;
const KeysName = styled.div `
  display: inline-block;
  color: currentColor;
  font-weight: 500;
  font-size: 12px;
`;
export const GraphKeys = (props) => {
    if (props.graphData.dataSets.length < 2) {
        return null;
    }
    return (React.createElement(Container, null, props.graphData.dataSets.map((dataSet, i) => (React.createElement(KeysItem, { key: i },
        React.createElement(KeysColor, { color: dataSet.color }),
        React.createElement(KeysName, null, dataSet.name))))));
};
